import React from "react";
import LoginForm from "./LoginForm";

const LoginMain = () => {
  return (
    <div id="react-contact" className="react-contact-page pt---100">
      <div className="container">
        <div className="row justify-content-center pb---96">
          <div className="col-lg-6">
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginMain;
